import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant, ExamStudentList, NoRecordFound } from 'src/app/constants/common-constant';
import { CommonService } from 'src/app/services/common/common.service';


@Component({
  selector: 'app-student-list',
  templateUrl: './student-list.component.html',
  styleUrls: ['./student-list.component.scss']
})
export class StudentListComponent implements OnInit {
  SelectedCollegeDataList:any;
  BatchIds:string='';
  StudentList:any;
  SortColumn: any = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  enterSearch: string = '';
  pageSizeOptions: number[] = [5, 10, 25, 100];
  CommonConstant: any = [];
  NoRecordFound: any = [];
  showData: boolean = false;
  ExamStudentList: any = [];
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  displayedColumns: string[] = ['rowNumber', 'StudentName', 'EmailId', 'MobileNo', 'BatchName', 'BatchYear','CollegeName','CollegeCode','isActive'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();

  
  constructor(private modalService: NgbModal,
              private apiUrl:ApiUrlHelper,
              private commonService:CommonService,
              private spinner:NgxSpinnerService,
              ){}
  
  onCancel(){
    this.modalService.dismissAll();
  }

  ngOnInit(): void {
    this.getStudentList();
    this.CommonConstant = CommonConstant;
    this.NoRecordFound = NoRecordFound;
    this.ExamStudentList = ExamStudentList;
  }
  getStudentList(){
    this.BatchIds = '';
    this.SelectedCollegeDataList.forEach(element => {
        element.Batches.forEach(ele => {
          this.BatchIds +=  ',' + ele.BatchId
        });
    });
    this.BatchIds = this.BatchIds.substring(1);
    const apiUrl = this.apiUrl.apiUrl.test.ExamStudentList;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection,
      BatchIds:this.BatchIds
    }
    this.commonService.doPost(apiUrl,objData).pipe().subscribe({
        next: (data) => {
          this.spinner.hide();
          if(data.success){
            this.StudentList = data.data;
            this.dataSource.data = this.StudentList
          }
          let TotalRecords = 0;
          if (this.StudentList.length > 0) {
            TotalRecords = this.StudentList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        },
        error: (err) => {
          this.spinner.hide();
        },
      });
  }
  SortChange(event) {
    this.sortDirection = event.direction ? event.direction : 'asc';
    this.SortColumn = event.active;
    this.getStudentList();
  }
  pageChanged(event) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getStudentList();
  }
}
